import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CheckRingDuotoneLine(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { cx: 12, cy: 12, r: 9, fill: "#7e869e", fillOpacity: 0.25, stroke: "currentColor", strokeWidth: 1.2 }), _jsx("path", { stroke: "currentColor", strokeWidth: 1.2, d: "m8 12 3 3 5-6" })] }) });
}
const CheckRingDuotoneLine = forwardRef(_CheckRingDuotoneLine);
export { CheckRingDuotoneLine };
